const SizesUtils = require('../../../viscomjs/utils/SizesUtils');
const mobileSize = 425;

module.exports = () => {
    const w = SizesUtils.winOffsetWidth();
    const h = SizesUtils.winOffsetHeight();
    const s = w <= mobileSize || h <= mobileSize ? 'mobile_' : '';
    return s + (w > h ? 'landscape' : 'portrait');
};



// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/utils/SizeMode.js